import ChatCoordinator from 'app/ChatCoordinator';
import AppProvider from 'contexts/app';
import AppBarProvider from 'contexts/appBar';
import DialogProvider from 'contexts/dialog';
import JoyrideProvider from 'contexts/joyride';
import NavigationGuardProvider from 'contexts/navigationGuard';
import SidebarLayoutProvider from 'contexts/sidebarLayout';
import ViewportProvider from 'contexts/viewport';
import WebsocketProvider from 'contexts/websocket';

const ProviderWrapper = ({ children }) => {
    return (
        <ViewportProvider>
            <AppBarProvider>
                <DialogProvider>
                    <NavigationGuardProvider>
                        <SidebarLayoutProvider>
                            <WebsocketProvider>
                                <ChatCoordinator>
                                    <AppProvider>
                                        <JoyrideProvider>{children}</JoyrideProvider>
                                    </AppProvider>
                                </ChatCoordinator>
                            </WebsocketProvider>
                        </SidebarLayoutProvider>
                    </NavigationGuardProvider>
                </DialogProvider>
            </AppBarProvider>
        </ViewportProvider>
    );
};

export default ProviderWrapper;
